<div class="content" *ngIf="emailVerified">
    <div class="card m-5">

        <div class="card-body">
            <h4 class="card-title">Link Expired</h4>
            <small style="font-size: 16px;margin-bottom: 15px;">Link Already Expired, Redirecting to Login
            </small>

        </div>
    </div>
</div>